module.exports = __webpack_public_path__ + "img/store8.61ce014f.jpg";